import axios from 'axios'

const jobManagementService = {
  getActiveList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/jobcode/listactiveproduct'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getInactiveList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/jobcode/listinactive'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getExpiredList(context) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/jobcode/listexpiredproduct'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getArchivedList() {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/jobcode/listarchiveproduct'
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  }
}

export default jobManagementService
